import React, { FC, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { FeedbackType } from 'types';
import { FEEDBACK_WITHOUT_REQUESTS_TYPES } from 'utils/models/Feedback';

const FeedbackTypeMultiSelector: FC<{
  onChange: (value: string) => void;
  types?: FeedbackType[];
}> = ({ onChange, types }) => {
  const [filterTypes, setFilterTypes] = useState<FeedbackType[]>([]);
  const { formatMessage } = useIntl();
  const toggleFilterType = useCallback(
    (tier: FeedbackType) => {
      if (!filterTypes.find((it) => it.id === tier.id)) {
        const updatedTypes = [...filterTypes, tier];
        setFilterTypes(updatedTypes);
        onChange(updatedTypes.map((it) => it.id).join(','));
      } else {
        const updatedTypes = filterTypes.filter((it) => it.id !== tier.id);
        setFilterTypes(updatedTypes);
        onChange(updatedTypes.map((it) => it.id).join(','));
      }
    },
    [filterTypes, onChange]
  );

  return (
    <ul className="pagination">
      {(types ?? FEEDBACK_WITHOUT_REQUESTS_TYPES(formatMessage)).map(
        (type: FeedbackType, index: number) => (
          <li
            key={index}
            className={
              'page-item' +
              (filterTypes.some((it) => it.id === type.id) ? ' active' : '')
            }
            role="button"
            onClick={() => toggleFilterType(type)}
          >
            <span className="page-link">
              <i className={'me-2 ' + type.icon} />
              {type.title}
            </span>
          </li>
        )
      )}
    </ul>
  );
};

export default React.memo(FeedbackTypeMultiSelector);
